import { render, staticRenderFns } from "./WorkspaceCreate.vue?vue&type=template&id=86a94a38&scoped=true"
import script from "./WorkspaceCreate.vue?vue&type=script&lang=ts"
export * from "./WorkspaceCreate.vue?vue&type=script&lang=ts"
import style0 from "./WorkspaceCreate.vue?vue&type=style&index=0&id=86a94a38&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86a94a38",
  null
  
)

export default component.exports